import React, { useEffect, useMemo, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import Footer from "../../Footer";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  hide_loader,
  set_sender_details,
  show_loader,
} from "../../actions/app";
import { getCurrentLocation } from "../../resources/get_current_location";
import api_requests from "../../resources/api_requests";
import utils from "../../resources/utils";
import constant from "../../resources/constant";
import { useTranslation } from "react-i18next";

const PickupAddress = () => {
  const dispacth = useDispatch();
  const navigate = useNavigate();
  const { sender_details } = useSelector((state) => state.app, shallowEqual);
  const [is_error, set_is_error] = useState(false);
  const [current_address, set_current_address] = useState();
  const [number_error, set_number_error] = useState(false);
  const biz_id = utils._retrieveData(constant.SELECTED_BUSINESS_ID);
  const { t } = useTranslation();

  useEffect(() => {
    if (!biz_id) {
      navigate("/business-select", { replace: true });
    }
  }, []);

  const [formData, setFormData] = useState({
    pickupAddress: "",
    senderName: "",
    senderNumber: "",
    saveAddress: "",
  });

  useEffect(() => {
    if (!_.isEmpty(sender_details)) {
      navigate("/dashboard");
    }
  }, []);
  const handle_skip = () => {
    navigate("/dashboard");
  };
  useEffect(() => {
    const user_data = utils._retrieveData(constant.USER_DETIALS);
    setFormData({
      senderName: user_data?.first_name,
      senderNumber: user_data?.mobile,
    });
  }, []);
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getCurrentLocation();
        set_current_address(response);
      } catch (error) {
        set_is_error(true);
      }
    }
    fetchData();
  }, []);

  const open_contacts = async () => {
    try {
      if ("contacts" in navigator && "select" in navigator.contacts) {
        const properties = ["name", "email", "tel"]; // Define what you want to access
        const options = { multiple: true }; // Allow selecting multiple contacts
        const contacts = await navigator.contacts.select(properties, options);
      } else {
        alert(t("contact_not_supported"));
      }
    } catch (error) {
      console.error(`${t("error_accessing")}: `, error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "senderNumber") {
      set_number_error(false);
    }
    if (name == "senderNumber" && value.length > 10) return;
    if (name == "saveAddress" && value.length > 10) return;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const _addrees = !_.isEmpty(sender_details)
      ? _.cloneDeep(sender_details)
      : _.cloneDeep(current_address);
    delete _addrees?.address_name;
    delete _addrees?.name;
    delete _addrees?.mobile;
    delete _addrees?.id;
    const data = {
      ..._addrees,
      address_line1: formData.pickupAddress,
      ...(!_.isEmpty(formData.saveAddress) && { label: formData.saveAddress }),
      is_saved: !_.isEmpty(formData.saveAddress),
    };
    try {
      dispacth(show_loader());
      const res = await api_requests.create_address(data);
      const newData = {
        ...data,
        name: formData.senderName,
        mobile: formData.senderNumber,
        id: res?.data?.address_id,
        address_name:
          sender_details?.address_name || current_address?.address_name,
      };
      dispacth(set_sender_details(newData));
      dispacth(hide_loader());
      navigate("/dashboard");
    } catch (error) {
      dispacth(hide_loader());
    }
  };

  const btn_disable = useMemo(() => {
    let value = true;
    if (
      formData.pickupAddress != "" &&
      formData.senderName != "" &&
      formData.senderNumber != "" &&
      formData?.senderNumber?.length == 10 &&
      !_.isEmpty(current_address)
    ) {
      value = false;
    }
    return value;
  }, [formData]);
  return (
    <div className="min-h-screen bg-white">
      <div className="flex p-6 justify-end">
        <p
          className="font-custom text-xs text-secondary font-medium"
          onClick={handle_skip}
        >
          Skip
        </p>
      </div>
      <div
        className="overflow-auto"
        style={{ height: `calc(100vh - 122px - env(safe-area-inset-bottom))` }}
      >
        <div className="text-center pl-12 pr-12 pb-10">
          <p className="font-custom text-2xl font-semibold text-secondary">
            {t("pickup_address")}
          </p>
          <p className="font-custom text-xs font-medium text-dark_gray mt-1">
            {t("about_pickup_address")}
          </p>
        </div>

        <div className="relative bg-[#7953d2]/20 py-4 px-12 flex justify-between items-center">
          {_.isEmpty(current_address) ? (
            <p className="font-custom text-sm text-dark_black font-medium">
              {is_error ? t("select_loc") : `${t("fetching_loc")}...`}
            </p>
          ) : (
            <div>
              <p className="font-custom text-sm text-dark_black font-bold">
                {current_address?.address_name}
              </p>
              <p className="font-custom text-dark_gray text-[10px] font-medium">
                {current_address?.formatted_address}
              </p>
            </div>
          )}

          <div className="font-custom self-start absolute top-[8px] right-[14px]">
            <button
              onClick={() => navigate("/search-location?type=pickup")}
              className="text-secondary text-[10px] font-medium border border-secondary py-[2px] px-[9px] rounded-full bg-white"
            >
              {is_error ? t("add") : t("change")}
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="pl-12 pr-12 pt-6 space-y-4">
          <div className="form-control">
            <label
              htmlFor="pickupAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary"
            >
              {t("pickup_address")}*
            </label>
            <textarea
              id="pickupAddress"
              name="pickupAddress"
              rows="4"
              value={formData.pickupAddress}
              onChange={handleInputChange}
              className="font-custom  p-2.5 w-full text-sm text-dark_black bg-white rounded-lg border border-accents focus:outline-accents "
              placeholder={t("enter_full_address")}
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="form-control">
              <label
                htmlFor="senderName"
                className="font-custom label-text font-semibold text-secondary"
              >
                {t("sender_name")}*
              </label>
              <input
                type="text"
                id="senderName"
                name="senderName"
                value={formData.senderName}
                onChange={handleInputChange}
                className="font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none   focus:outline-none focus:ring-0 focus:border-accents peer"
                placeholder={t("enter_name")}
              />
            </div>
            <div className="form-control">
              <label
                htmlFor="senderNumber"
                className={`font-custom label-text font-semibold text-${
                  number_error ? "error" : "secondary"
                }`}
              >
                {t("sender_num")}*
              </label>
              <div className="flex gap-1">
                <input
                  type="number"
                  id="senderNumber"
                  name="senderNumber"
                  value={formData.senderNumber}
                  onChange={handleInputChange}
                  style={{ borderColor: number_error ? "#BC0000" : "" }}
                  className={`font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none dark:border-accents-600 dark:focus:border-accents focus:outline-none focus:ring-0 focus:border-accents peer`}
                  placeholder={t("enter_mobile_number")}
                  onBlur={() => {
                    if (formData.senderNumber.length < 10) {
                      set_number_error(true);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {number_error && (
            <p
              className="font-custom font-medium	text-[10px] text-error"
              style={{ marginTop: 2 }}
            >
              {t("invalid_contact_number")}
            </p>
          )}
          <div className="form-control pt-2">
            <label
              htmlFor="saveAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary"
            >
              {t("save_address_label")}
            </label>
            <input
              type="text"
              id="saveAddress"
              name="saveAddress"
              value={formData.saveAddress}
              onChange={handleInputChange}
              className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
              placeholder={t("address_placeholder")}
            />
          </div>

          <div className="form-control" style={{ marginTop: "40px" }}>
            <button
              type="submit"
              className={`font-custom w-full py-3 rounded-[30px] text-base font-semibold
                ${
                  btn_disable
                    ? "bg-gray text-gray-200 cursor-not-allowed"
                    : "bg-[#492897] text-white"
                }`}
              disabled={btn_disable}
            >
              {t("add_pickup_address")}
            </button>
          </div>
        </form>
      </div>
      <Footer bottom={0} />
    </div>
  );
};

export default PickupAddress;
